import {
	AccordionContent,
	AccordionTrigger,
	DatePicker,
	FormItem,
	Label,
} from '@uturn/ui-kit';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FilterContext } from './context';

export function DateFilter() {
	const { filters, setFilters } = useContext(FilterContext);
	const { t } = useTranslation();
	return (
		<>
			<AccordionTrigger>
				{t('pages.shipments.filters.date.title', 'date')}
			</AccordionTrigger>
			<AccordionContent className="grid grid-cols-2 gap-3 lg:grid-cols-none">
				<FormItem>
					<Label>{t('pages.shipments.filters.date.from', 'From')}</Label>
					<DatePicker
						type="date"
						value={
							filters['filter.fromDateTime']
								? new Date(filters['filter.fromDateTime'])
								: undefined
						}
						selected={
							filters['filter.fromDateTime']
								? new Date(filters['filter.fromDateTime'])
								: undefined
						}
						onSelect={(value) => {
							if (!value) {
								setFilters({
									'filter.fromDateTime': undefined,
								});
								return;
							}

							value.setHours(0, 0, 0, 0);
							setFilters({
								'filter.fromDateTime': value.toISOString(),
							});
						}}
					/>
				</FormItem>
				<FormItem>
					<Label>{t('pages.shipments.filters.date.until', 'Until')}</Label>
					<DatePicker
						type="date"
						value={
							filters['filter.untilDateTime']
								? new Date(filters['filter.untilDateTime'])
								: undefined
						}
						selected={
							filters['filter.untilDateTime']
								? new Date(filters['filter.untilDateTime'])
								: undefined
						}
						onSelect={(value) => {
							if (!value) {
								setFilters({
									'filter.untilDateTime': undefined,
								});
								return;
							}

							value.setHours(23, 59, 0, 0);
							setFilters({
								'filter.untilDateTime': value.toISOString(),
							});
						}}
					/>
				</FormItem>
			</AccordionContent>
		</>
	);
}
